$(document).on('click', '.shoe-tabs__btn', function(e) {
    setShoeTab(this)
})

function setShoeTab(el){
    let tab = $(el).attr("data-tab")

    $(el).parents(".shoe-card").find(".shoe-tabs__btn").removeClass("_active")
    $(el).parents(".shoe-card").find(`.shoe-tabs__btn[data-tab="${tab}"]`).addClass("_active")
    $(el).parents(".shoe-card").find(".shoe-content").removeClass("_active")
    $(el).parents(".shoe-card").find(`.shoe-content[data-tab="${tab}"]`).addClass("_active")
}

$(document).on('click', '.shoe-article__btn', function(e) {
    setShoeArticle(this)
})

function setShoeArticle(el){
    let tab = $(el).attr("data-tab")

    $(el).parents(".shoe-content").find(".shoe-article__btn").removeClass("_active")
    $(el).parents(".shoe-content").find(`.shoe-article__btn[data-tab="${tab}"]`).addClass("_active")
    $(el).parents(".shoe-content").find(".article-content").removeClass("_active")
    $(el).parents(".shoe-content").find(`.article-content[data-tab="${tab}"]`).addClass("_active")
}



// showCalcHint("В наличии больше нет",$(".shoe-card:first-child .cartcalc"))

function showCalcHint(text,element) {
    let tooltip = `
    <div class="m-tooltip">
        <div class="m-tooltip__inner">
            <div class="text12">
            ${text}          
            </div>
        </div>
    </div>    
    `

    $(element).append(tooltip)

    setTimeout(()=>{
        hideCalcHint(element)
    },5000)
}


function hideCalcHint(element) {
    $(element).find(".m-tooltip").remove()
}

$(document).on('click', '.qa-card__show', function(e) {
    $(this).parents(".qa-card").toggleClass("_active")
    $(this).siblings(".qa-card__hidden").slideToggle()
})
